import SubdomainSite from "@/subdomains/SubdomainSite";
import config from "@/subdomains/configs/leadscoring";

/** LeadscoringBizlem page — leadscoring.bizlem.com */
export default function LeadscoringPage() {
  return <SubdomainSite config={config} />;
}

export { config };
